export default "## Overall Score\n\nThis score is the average of the individual match scores.\n";